import { Component } from '@angular/core';
import { ActionSheetController, IonicPage, ModalController, NavController, NavParams, Platform } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CabsandPrestartPage } from '../cabsand-prestart/cabsand-prestart';
import { CabsandPrestartJobcardPage } from '../cabsand-prestart-jobcard/cabsand-prestart-jobcard';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { SearchPage } from '../search/search';
import { SelectImagePopupPage } from '../select-image-popup/select-image-popup';

@IonicPage()
@Component({
  selector: 'page-cabsand-addprestart',
  templateUrl: 'cabsand-addprestart.html',
})
export class CabsandAddprestartPage {
  fleetList: any = [];
  locationList: any = [];
  selectedFleet: any = "Select";
  selectedLocation: any;
  selectedFleetItems: any = [];
  selectOptions: any;
  createPrestart: FormGroup;
  isUpdate: boolean = false;
  isFaulty: boolean = false;
  params: any = {};
  appColor: String;
  vehicleType: any = "";
  actionAllowed:boolean = false;
  disableField:boolean = false;
  notes: any = '';

  showJobCardButton:boolean = true;
  buttonText:any = null;
  disableSubmit:boolean = false;

  constructor(public camera:Camera,public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, public actionSheetController: ActionSheetController,
    public platform: Platform, private modalController: ModalController) {

      this.selectOptions = {
        mode: 'ios'
      };
      this.params = this.navParams.get('param');
      if (this.params) {
        this.isUpdate = true;
        if(this.params.disableField){
          this.disableField = this.params.disableField;
        }
  
        if(this.params.prestart_id){
          this.showJobCardButton = false;
          if(this.params.job_no){
            this.buttonText = this.params.job_no;
          }
        }
      }
      let currentDate = new Date()
       var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
  
      this.createPrestart = this.formBuilder.group({
        // user_id: new FormControl('', [Validators.required]),
        // fleet_no: new FormControl('', [Validators.required]),
        // date: new FormControl(date, [Validators.required]),
        // hours: new FormControl('0'),
        // kilometers: new FormControl('0'),
        // drivername: new FormControl('', [Validators.required]),
        // location: new FormControl('', [Validators.required]),
        // oils_added: new FormControl('', [Validators.required]),

        user_id: new FormControl('', [Validators.required]),
        fleet_no: new FormControl('', [Validators.required]),
        date: new FormControl(date, [Validators.required]),
        hours: new FormControl(''),
        kilometers: new FormControl(''),
        drivername: new FormControl('', [Validators.required]),
        location: new FormControl(''),
        oils_added: new FormControl('', [Validators.required]),
      });
      console.log("param", this.params)
    }
  
    ionViewDidLoad() {
      console.log('ionViewDidLoad');
      this.getPermission();
  
      this.getappColor();
      this.getMetaData();
  
    }
  
    checkStatus(string) {
      return string.includes("Faulty");
    }
  
    async getappColor() {
      this.appColor = await this.utiltiy.getStorage("primaryColor");
    }
    async getMetaData() {
      let userId = await this.utiltiy.getStorage("userId");
      let userName = await this.utiltiy.getStorage("name");
      if (userId) {
        this.createPrestart.get(`user_id`).setValue(userId);
        // this.createPrestart.get(`drivername`).setValue(userName);
      }
      this.fleetList = await this.getFleetList();
      this.locationList = await this.getLocationList();
      if (this.params) {
        this.regenerateForm();
        this.regenerateFleetList();
        this.isFaulty = this.params.item_status.includes("Faulty");
      }
    }
  
    async getFleetList() {
      this.fleetList = [];
      this.utiltiy.startLoading();
      let formData: FormData = new FormData();
        formData.append("method_name", "get_fleet_no");
      return this.api.post("/tansix_prestart/fleet/get",false,formData)
        .then((result: any) => {
          console.log("result", result)
          this.utiltiy.stopLoading();
          if (result.status) {
            return result.result;
          }
        }, err => {
          this.utiltiy.stopLoading();
          this.utiltiy.toaster(err.error.message);
          return [];
        })
    }
    async getLocationList() {
      this.locationList = [];
      this.utiltiy.startLoading();
      return this.api.get("/tansix_prestart/location/get", false)
        .then((result: any) => {
          console.log("result", result)
          this.utiltiy.stopLoading();
          if (result.status) {
            return result.result;
          }
        }, err => {
          this.utiltiy.stopLoading();
          this.utiltiy.toaster(err.error.message);
          return [];
        })
    }
  
    async mobileUploads(index) {
      const actionSheet = await this.actionSheetController.create({
        title: 'Select Image source',
        buttons: [
          {
            text: 'Load from Library',
            handler: () => {
              this.pickImage(this.camera.PictureSourceType.PHOTOLIBRARY, index);
            },
          },
          {
            text: 'Use Camera',
            handler: () => {
              this.pickImage(this.camera.PictureSourceType.CAMERA, index);
            },
          },
          {
            text: 'Cancel',
            role: 'cancel',
          },
        ],
      });
      await actionSheet.present();
      // this.onInput('', 'Photography');
    }
  
    pickImage(sourceType, index) {
      let image: any;
  
      const options: CameraOptions = {
        quality: 20,
        sourceType: sourceType,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
      };
      this.camera.getPicture(options).then(
        (imageData) => {
          image = 'data:image/jpeg;base64,' + imageData;
          this.selectedFleetItems[index].isBase64 = true;
  
      this.base64tofile(image,this.selectedFleetItems[index].name,index);
  
        // this.loadingService.dismissLoading();
        },
  
        (err) => {
          // this.loadingService.dismissLoading();
          console.log("errOf Image ", err)
        }
      );
    }
  
    clearImage(i) {
      this.selectedFleetItems[i].photo = '';
    }
  
    async onPhotoGraphy(event, type, index) {
      if (type == 1) {
        this.mobileUploads(index)
      } else if (type == 2) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.utiltiy.getBase64(event.target.files[i]).then(
            async (data: any) => {
              console.log("data", data)
              // this.selectedFleetItems[index].photo = data;
              this.selectedFleetItems[index].isBase64 = true;
               this.base64tofile(data,this.selectedFleetItems[index].name,index);
            }).catch(error => {
              console.log('error', error);
            });
        }
      }
    }
  
  
    async base64tofile(base64, fileName, index) {
      const res: Response = await fetch(base64);
      const blob: Blob = await res.blob();
      const file = new File([blob], fileName.replace(/ /g, '') + `.png`, { type: 'image/png' });
      this.selectedFleetItems[index].photo = file
      this.selectedFleetItems[index].base64 = base64
      console.log(file);
    }
  
    regenerateForm() {
      this.createPrestart.patchValue({
        user_id: this.params.user_id,
        date: this.params.date,
        hours: this.params.hours,
        kilometers: this.params.kilometers,
        drivername: this.params.drivername,
        location: this.params.location,
        oils_added: this.params.oils_added,
      });
      // this.selectedFleet = this.params.fleet_id;
      this.selectedLocation = this.params.location;
      this.fleetChanged(this.params.fleet_id);
    }
  
    regenerateFleetList(){
      let index = this.fleetList.findIndex(list_ => list_['id'] == this.params.fleet_no);
      if(index != -1){
        this.selectedFleet = this.fleetList[index].fleet_no;
      }
    }
  
  
    async openModal(list, title, key, value, model, formkey) {
      list = await this.createData(list, key, value);
      console.log("list", list)
      const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
      profileModal.onDidDismiss(data => {
        console.log(data);
        if (data) {
          this.createPrestart.get(formkey).setValue(data.key);
          this[model] = data.value;
          if(formkey == "fleet_no"){
            this.fleetChanged(data.key);
          }
        }
      });
      profileModal.present();
  
    }
  
    async createData(list, key, value) {
      list.forEach(element => {
        element.key = element[key];
        element.value = element[value];
      });
  
      return list;
    }
  
    dropDownChange(value, key) {
      this.createPrestart.get(`${key}`).setValue(value);
    }
  
  
  
    fleetChanged(fleetData) {
      console.log(this.fleetList, "fleetName", fleetData)
      let index = this.fleetList.findIndex(list_ => list_.id.toLowerCase() == fleetData.toLowerCase());
      if (index == -1) {
        return;
      }
  
      this.createPrestart.patchValue({
        fleet_no: fleetData,
      });
      this.vehicleType = this.fleetList[index].vehicle_category;
      const vehicles = this.fleetList[index].vehicles;
      let status = vehicles.includes(",");
      let vehicleList = [];
      console.log("status", status)
  
      if (status) {
        vehicleList = vehicles.split(",");
      } else {
        vehicleList.push(vehicles);
      }
      this.generateFleetItemList(vehicleList);
    }
  
  
    generateFleetItemList(list) {
      this.selectedFleetItems = [];
      list.forEach((vehicle_, i) => {
        var obj = {}
        if (this.isUpdate) {
          let status = this.params.item_status.includes(",");
          if (status) {
            let item_status = this.params.item_status.split(",");
            let comment = this.params.comment.split("||||");
            let photo = this.params.photo.split("||||");
            if(!photo[i]){
              photo[i] = "";
            }
  console.log("comment",photo)
            obj = {
              "name": vehicle_,
              "status": item_status[i],
              "comments": comment[i],
              "photo": photo[i],
              "isBase64": false,
            }
          } else {
            obj = {
              "name": vehicle_,
              "status": this.params.item_status,
              "comments": this.params.comment,
              "photo": this.params.photo,
              "isBase64": false,
  
            }
          }
        } else {
          obj = {
            "name": vehicle_,
            "status": null,
            "comments": "",
            "photo": "",
            "isBase64": false,
          }
        }
        this.selectedFleetItems.push(obj);
      });
      console.log("vehicleList", this.selectedFleetItems);
  
    }
  
    async generateFileFromBase64(list, i) {
      if (i == list.length) {
        return list;
      } else {
        list.forEach(async (element) => {
          if (element.photo.includes("data:image")) {
            const res: Response = await fetch(element.photo);
            const blob: Blob = await res.blob();
            const file = new File([blob], element.name.replace(/ /g, '') + `.png`, { type: 'image/png' });
            element.photo = file;
          }
        })
  
        i++
        this.generateFileFromBase64(list, i)
      }
  
    }
  
    async validateForm(){
      let statucCount = 0;
      let faultyCount = 0;
      let faultyCommentCount = 0;
      let faultyImageCount = 0;
      this.selectedFleetItems.forEach((element) => {
        if(element.status != null){
          statucCount++
        }
        if(element.status == "Faulty"){
          faultyCount++
          if(element.comments.length > 0){
            faultyCommentCount++
          }
          if(element.photo != ''){
            faultyImageCount++
          }
        }
  
      });
      console.log("statucCount",statucCount);
      console.log("faultyCount",faultyCount);
      console.log("faultyCommentCount",faultyCommentCount);
      console.log("selectedFleetItems",this.selectedFleetItems.length);
      if(this.selectedFleetItems.length !== statucCount){
        return false;
      }else if(faultyCount !== faultyCommentCount){
        return false;
      }else if(faultyCommentCount !== faultyImageCount){
        return true;
        
      }
      else{
        return true;
      }
    }
  
  
    async submit() {
      let status = await this.validateForm();
      console.log("status",status)
      this.utiltiy.startLoading();
      this.disableSubmit = true;
      console.log("this.credentialsForm.value", this.createPrestart.value)
      // this.selectedFleetItems = await this.generateFileFromBase64(this.selectedFleetItems,0);
      console.log("vehicleList", this.selectedFleetItems);
  
      let items = "";
      let item_status = "";
      let comment = "";
      let photo = "";
  
      let formKeys = Object.keys(this.createPrestart.value);
  
      this.selectedFleetItems.forEach((element) => {
        items = items + element.name + ","
        item_status = item_status + element.status + ","
        comment = comment + element.comments + "||||"
        // photo = photo + element.photo + "||||"
      });
      // console.log("photo", photo)
      // this.selectedFleetItems.forEach((element) => {
      //   if(element.photo != ""){
      //     formData.append("photo[]",element.photo);
      //     formData.append("photo[]","||||");
      //   }else{
      //     formData.append("photo[]","||||");
      //   }
      // })
      items = items.slice(0, items.length - 1);
      item_status = item_status.slice(0, item_status.length - 1);
      // comment = comment.slice(0, comment.length - 1);
      // photo = photo.slice(0, photo.length - 1);
  
  
  
      if (this.isUpdate) {
        // let string = "";
        // formKeys.forEach(key => {
        //   if (string.length == 0) {
        //     string = string + "" + key + "=" + this.createPrestart.value[key];
        //   } else {
        //     string = string + "&" + key + "=" + this.createPrestart.value[key];
        //   }
        // });
        // this.selectedFleetItems.forEach(async (element) => {
        //   if (element.photo){
        //     photo = photo + "&photo[]=" + `${element.photo}`
        //   }else{
        //     const file = new File([], "", { });
        //     photo = photo + "&photo[]=" + `${file}`
        //   }
        // })
        // console.log("photo",photo)
        // let body = string + "&items[]=" + `${items}` + "&item_status[]=" + `${item_status}` + "&comment[]=" + `${comment}` + `${photo}`;
        // console.log("string-1", body);
  
        let formData: FormData = new FormData();
        formKeys.forEach(key => {
          formData.append(key, this.createPrestart.value[key]);
        });
        formData.append("id", this.params.id);
        formData.append("method_name", "update_prestart");
        formData.append("items[]", items);
        formData.append("item_status[]", item_status);
        formData.append("comment[]", comment);
  
        this.selectedFleetItems.forEach(async (element) => {
          if (element.photo != "") {
            formData.append("photo[]", element.photo);
            // formData.append("photo[]", "||||");
          } else {
            const file = new File([], "", { });
            formData.append("photo[]",file);
          }
        })
        this.updatePrestart(formData);
      } else {
        let formData: FormData = new FormData();
        formKeys.forEach(key => {
          formData.append(key, this.createPrestart.value[key]);
        });
        formData.append("items[]", items);
        formData.append("item_status[]", item_status);
        formData.append("comment[]", comment);
  
        this.selectedFleetItems.forEach(async (element) => {
          if (element.photo != "") {
            formData.append("photo[]", element.photo);
            // formData.append("photo[]", "||||");
          } else {
            const file = new File([], "", { });
            formData.append("photo[]",file);
          }
        })
        this.addPrestart(formData);
      }
  
  
  
    }
  
    async getImage(path: any) {
      console.log("this.params.file_uploaded_path+path", this.params.file_uploaded_path + path)
      return this.params.file_uploaded_path + path;
    }
  
    addPrestart(formData) {
      this.api.post(`/tansix_prestart/store`, false, formData)
        .then((result: any) => {
          console.log("result", result)
      this.disableSubmit = false;

          this.utiltiy.stopLoading();
          if (result.status) {
            this.utiltiy.toaster(result.message);
            this.navCtrl.setRoot(CabsandPrestartPage);
          }
  
        }, err => {
          console.log("err", err)
      this.disableSubmit = false;

          this.utiltiy.stopLoading();
          this.utiltiy.toaster(err.error.message);
        })
    }
  
    updatePrestart(formData) {
      // this.api.put(`/tansix_prestart/update/${id}`, false, formData)
      //   .then((result: any) => {
      //     console.log("result", result)
      //     this.utiltiy.stopLoading();
      //     if (result.status) {
      //       this.utiltiy.toaster(result.message);
      //       this.navCtrl.setRoot(PrestartPage);
      //     }
  
      //   }, err => {
      //     console.log("err", err)
      //     this.utiltiy.stopLoading();
      //     this.utiltiy.toaster(err.error.message);
      //   })
  
      this.api.post(`/tansix_prestart/Prestart`, false, formData)
        .then((result: any) => {
          console.log("result", result)
      this.disableSubmit = false;

          this.utiltiy.stopLoading();
          if (result.status) {
            this.utiltiy.toaster(result.message);
            this.navCtrl.setRoot(CabsandPrestartPage);
          }
  
        }, err => {
          console.log("err", err)
      this.disableSubmit = false;

          this.utiltiy.stopLoading();
          this.utiltiy.toaster(err.error.message);
        })
    }
  
    stringFromArray() {
  
    }

    async openImage(img) {
      const modal = await this.modalController.create(SelectImagePopupPage, { param: img });
      await modal.present();
    }
  
    
  
    createJob() {
      this.params.notes = this.notes;
      this.params.fleetList = this.selectedFleetItems;
      this.params.jobDescription = `Fleet number - ${this.params.fleet_name}, Prestart number - ${this.params.id}, Jobcard created by - ${this.params.drivername}`;
      this.navCtrl.push(CabsandPrestartJobcardPage, { param: null, fleet: null, payload: this.params });
    }
  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-prestart-rw");
   }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-addprestart/cabsand-addprestart.ts